define("Config", [`lodash`], function (_) {
	const SiteConfig = _.isObject(window.SiteConfig) ? window.SiteConfig : {};
	const staticImgPath = SiteConfig.STATIC_IMG_PATH;
	const staticImg = _.isUndefined(staticImgPath) ? `/static/images` : staticImgPath;
	const config = _.chain({
		// Hard-coded definitions
		NAME: `Tixr`,

		STATIC_JS_PATH: SiteConfig.STATIC_JS_PATH,
		STATIC_FONT_PATH: SiteConfig.STATIC_FONT_PATH,

		LOGOUT_INTERVAL: 3600000, //Log user out after an hour, 60 min * 60 sec * 1000 ms
		KEEPALIVE_INTERVAL: 600000, //Ping the server to keep the session alive every 10 minutes, 10 min * 60 sec * 1000 ms

		NAV_MOUSEOUT_TOOLTIP_DELAY: 50,
		LOADING_SPINNER_DELAY: 250,
		NOTIFICATION_DELAYS: {
			message: 4000,
			success: 4000,
			error: 8000,
		},

		DEFAULT_CURRENCIES: [`USD`],

		REGEX: {
			email: `^[\\w\\-\\+%]+(\\.[\\w\\-\\+%]+)*@[\\w\\-\\+%]+(\\.[\\w\\-\\+%]+)+$`,
			postalCode: `^[a-zA-Z0-9.][a-zA-Z0-9. -]{0,24}$`,
			phoneNumber: `^\\+?[0-9 \\-\\.\\(\\)#]{0,41}$`,
			dateString: `^\\d{4}-\\d{2}-\\d{2}$`,
			last4: `^\\d{4}$`,
		},

		CVV_TOOLTIP_IMAGE_DEFAULT: `${staticImg}/tooltip-cvv.png`,
		CVV_TOOLTIP_IMAGE_AMEX: `${staticImg}/tooltip-cvv-amex.png`,

		CHECKOUT_TIMEOUT_DURATION: 600, // 10 min * 60 sec, measured in seconds, not ms

		ADMISSION_TYPE_LABEL: {
			ONE_TIME: `One time entry`,
			DAILY: `One entry per day`,
			NO_CAP: `Unlimited entries`,
			CAP: `Limited entries`,
			ENTRY_WINDOW: `Entry Window`,
		},

		ALL_COUNTRIES: [
			`AF`,
			`AX`,
			`AL`,
			`DZ`,
			`AD`,
			`AO`,
			`AI`,
			`AQ`,
			`AG`,
			`AR`,
			`AM`,
			`AW`,
			`AU`,
			`AT`,
			`AZ`,
			`BS`,
			`BH`,
			`BD`,
			`BB`,
			`BY`,
			`BE`,
			`BZ`,
			`BJ`,
			`BM`,
			`BT`,
			`BO`,
			`BQ`,
			`BA`,
			`BW`,
			`BV`,
			`BR`,
			`IO`,
			`BN`,
			`BG`,
			`BF`,
			`BI`,
			`KH`,
			`CM`,
			`CA`,
			`CV`,
			`KY`,
			`CF`,
			`TD`,
			`CL`,
			`CN`,
			`CO`,
			`KM`,
			`CG`,
			`CD`,
			`CK`,
			`CR`,
			`CI`,
			`HR`,
			`CW`,
			`CY`,
			`CZ`,
			`DK`,
			`DJ`,
			`DM`,
			`DO`,
			`EC`,
			`EG`,
			`SV`,
			`GQ`,
			`ER`,
			`EE`,
			`ET`,
			`FK`,
			`FO`,
			`FJ`,
			`FI`,
			`FR`,
			`GF`,
			`PF`,
			`TF`,
			`GA`,
			`GM`,
			`GE`,
			`DE`,
			`GH`,
			`GI`,
			`GR`,
			`GL`,
			`GD`,
			`GP`,
			`GU`,
			`GT`,
			`GG`,
			`GN`,
			`GW`,
			`GY`,
			`HT`,
			`HN`,
			`HK`,
			`HU`,
			`IS`,
			`IN`,
			`ID`,
			`IQ`,
			`IE`,
			`IM`,
			`IL`,
			`IT`,
			`JM`,
			`JP`,
			`JE`,
			`JO`,
			`KZ`,
			`KE`,
			`KI`,
			`KR`,
			`KW`,
			`KG`,
			`LA`,
			`LV`,
			`LB`,
			`LS`,
			`LR`,
			`LY`,
			`LI`,
			`LT`,
			`LU`,
			`MO`,
			`MK`,
			`MG`,
			`MW`,
			`MY`,
			`MV`,
			`ML`,
			`MT`,
			`MQ`,
			`MR`,
			`MU`,
			`YT`,
			`MX`,
			`MD`,
			`MC`,
			`MN`,
			`ME`,
			`MS`,
			`MA`,
			`MZ`,
			`MM`,
			`NA`,
			`NR`,
			`NP`,
			`NL`,
			`NC`,
			`NZ`,
			`NI`,
			`NE`,
			`NG`,
			`NU`,
			`NO`,
			`OM`,
			`PK`,
			`PS`,
			`PA`,
			`PG`,
			`PY`,
			`PE`,
			`PH`,
			`PN`,
			`PL`,
			`PT`,
			`PR`,
			`QA`,
			`RE`,
			`RO`,
			`RU`,
			`RW`,
			`BL`,
			`SH`,
			`KN`,
			`LC`,
			`MF`,
			`PM`,
			`VC`,
			`WS`,
			`SM`,
			`ST`,
			`SA`,
			`SN`,
			`RS`,
			`SC`,
			`SL`,
			`SG`,
			`SX`,
			`SK`,
			`SI`,
			`SB`,
			`SO`,
			`ZA`,
			`GS`,
			`SS`,
			`ES`,
			`LK`,
			`SD`,
			`SR`,
			`SJ`,
			`SZ`,
			`SE`,
			`CH`,
			`TW`,
			`TJ`,
			`TZ`,
			`TH`,
			`TL`,
			`TG`,
			`TK`,
			`TO`,
			`TT`,
			`TN`,
			`TR`,
			`TM`,
			`TC`,
			`TV`,
			`UG`,
			`UA`,
			`AE`,
			`GB`,
			`US`,
			`UY`,
			`UZ`,
			`VU`,
			`VA`,
			`VE`,
			`VN`,
			`VG`,
			`WF`,
			`EH`,
			`YE`,
			`ZM`,
			`ZW`,
		],

		COUNTRY_OPTIONS: [
			{ alias: `United States of America`, label: `U.S.A.`, value: `US` },
			{ label: `Afghanistan`, value: `AF` },
			{ label: `Åland`, value: `AX` },
			{ label: `Albania`, value: `AL` },
			{ label: `Algeria`, value: `DZ` },
			{ label: `Andorra`, value: `AD` },
			{ label: `Angola`, value: `AO` },
			{ label: `Anguilla`, value: `AI` },
			{ label: `Antarctica`, value: `AQ` },
			{ label: `Antigua and Barbuda`, value: `AG` },
			{ label: `Argentina`, value: `AR` },
			{ label: `Armenia`, value: `AM` },
			{ label: `Aruba`, value: `AW` },
			{ label: `Australia`, value: `AU` },
			{ label: `Austria`, value: `AT` },
			{ label: `Azerbaijan`, value: `AZ` },
			{ label: `Bahamas`, value: `BS` },
			{ label: `Bahrain`, value: `BH` },
			{ label: `Bangladesh`, value: `BD` },
			{ label: `Barbados`, value: `BB` },
			{ label: `Belarus`, value: `BY` },
			{ label: `Belgium`, value: `BE` },
			{ label: `Belize`, value: `BZ` },
			{ label: `Benin`, value: `BJ` },
			{ label: `Bermuda`, value: `BM` },
			{ label: `Bhutan`, value: `BT` },
			{ label: `Bolivia`, value: `BO` },
			{ label: `Bonaire, Sint Eustatius and Saba`, value: `BQ` },
			{ label: `Bosnia and Herzegovina`, value: `BA` },
			{ label: `Botswana`, value: `BW` },
			{ label: `Bouvet Island`, value: `BV` },
			{ label: `Brazil`, value: `BR` },
			{ label: `British Indian Ocean Territory`, value: `IO` },
			{ label: `Brunei Darussalam`, value: `BN` },
			{ label: `Bulgaria`, value: `BG` },
			{ label: `Burkina Faso`, value: `BF` },
			{ label: `Burundi`, value: `BI` },
			{ label: `Cambodia`, value: `KH` },
			{ label: `Cameroon`, value: `CM` },
			{ label: `Canada`, value: `CA` },
			{ label: `Cape Verde`, value: `CV` },
			{ label: `Cayman Islands`, value: `KY` },
			{ label: `Central African Republic`, value: `CF` },
			{ label: `Chad`, value: `TD` },
			{ label: `Chile`, value: `CL` },
			{ label: `China`, value: `CN` },
			{ label: `Colombia`, value: `CO` },
			{ label: `Comoros`, value: `KM` },
			{ label: `Congo (Brazzaville)`, value: `CG` },
			{ label: `Congo (Kinshasa)`, value: `CD` },
			{ label: `Cook Islands`, value: `CK` },
			{ label: `Costa Rica`, value: `CR` },
			{ label: `Côte d'Ivoire`, value: `CI` },
			{ label: `Croatia`, value: `HR` },
			{ label: `Curaçao`, value: `CW` },
			{ label: `Cyprus`, value: `CY` },
			{ label: `Czech Republic`, value: `CZ` },
			{ label: `Denmark`, value: `DK` },
			{ label: `Djibouti`, value: `DJ` },
			{ label: `Dominica`, value: `DM` },
			{ label: `Dominican Republic`, value: `DO` },
			{ label: `Ecuador`, value: `EC` },
			{ label: `Egypt`, value: `EG` },
			{ label: `El Salvador`, value: `SV` },
			{ label: `Equatorial Guinea`, value: `GQ` },
			{ label: `Eritrea`, value: `ER` },
			{ label: `Estonia`, value: `EE` },
			{ label: `Ethiopia`, value: `ET` },
			{ label: `Falkland Islands`, value: `FK` },
			{ label: `Faroe Islands`, value: `FO` },
			{ label: `Fiji`, value: `FJ` },
			{ label: `Finland`, value: `FI` },
			{ label: `France`, value: `FR` },
			{ label: `French Guiana`, value: `GF` },
			{ label: `French Polynesia`, value: `PF` },
			{ label: `French Southern Lands`, value: `TF` },
			{ label: `Gabon`, value: `GA` },
			{ label: `Gambia`, value: `GM` },
			{ label: `Georgia`, value: `GE` },
			{ label: `Germany`, value: `DE` },
			{ label: `Ghana`, value: `GH` },
			{ label: `Gibraltar`, value: `GI` },
			{ label: `Greece`, value: `GR` },
			{ label: `Greenland`, value: `GL` },
			{ label: `Grenada`, value: `GD` },
			{ label: `Guadeloupe`, value: `GP` },
			{ label: `Guam`, value: `GU` },
			{ label: `Guatemala`, value: `GT` },
			{ label: `Guernsey`, value: `GG` },
			{ label: `Guinea`, value: `GN` },
			{ label: `Guinea-Bissau`, value: `GW` },
			{ label: `Guyana`, value: `GY` },
			{ label: `Haiti`, value: `HT` },
			{ label: `Honduras`, value: `HN` },
			{ label: `Hong Kong`, value: `HK` },
			{ label: `Hungary`, value: `HU` },
			{ label: `Iceland`, value: `IS` },
			{ label: `India`, value: `IN` },
			{ label: `Indonesia`, value: `ID` },
			{ label: `Iraq`, value: `IQ` },
			{ label: `Ireland`, value: `IE` },
			{ label: `Isle of Man`, value: `IM` },
			{ label: `Israel`, value: `IL` },
			{ label: `Italy`, value: `IT` },
			{ label: `Jamaica`, value: `JM` },
			{ label: `Japan`, value: `JP` },
			{ label: `Jersey`, value: `JE` },
			{ label: `Jordan`, value: `JO` },
			{ label: `Kazakhstan`, value: `KZ` },
			{ label: `Kenya`, value: `KE` },
			{ label: `Kiribati`, value: `KI` },
			{ label: `Korea, South`, value: `KR` },
			{ label: `Kuwait`, value: `KW` },
			{ label: `Kyrgyzstan`, value: `KG` },
			{ label: `Laos`, value: `LA` },
			{ label: `Latvia`, value: `LV` },
			{ label: `Lebanon`, value: `LB` },
			{ label: `Lesotho`, value: `LS` },
			{ label: `Liberia`, value: `LR` },
			{ label: `Libya`, value: `LY` },
			{ label: `Liechtenstein`, value: `LI` },
			{ label: `Lithuania`, value: `LT` },
			{ label: `Luxembourg`, value: `LU` },
			{ label: `Macau`, value: `MO` },
			{ label: `Macedonia`, value: `MK` },
			{ label: `Madagascar`, value: `MG` },
			{ label: `Malawi`, value: `MW` },
			{ label: `Malaysia`, value: `MY` },
			{ label: `Maldives`, value: `MV` },
			{ label: `Mali`, value: `ML` },
			{ label: `Malta`, value: `MT` },
			{ label: `Martinique`, value: `MQ` },
			{ label: `Mauritania`, value: `MR` },
			{ label: `Mauritius`, value: `MU` },
			{ label: `Mayotte`, value: `YT` },
			{ label: `Mexico`, value: `MX` },
			{ label: `Moldova`, value: `MD` },
			{ label: `Monaco`, value: `MC` },
			{ label: `Mongolia`, value: `MN` },
			{ label: `Montenegro`, value: `ME` },
			{ label: `Montserrat`, value: `MS` },
			{ label: `Morocco`, value: `MA` },
			{ label: `Mozambique`, value: `MZ` },
			{ label: `Myanmar`, value: `MM` },
			{ label: `Namibia`, value: `NA` },
			{ label: `Nauru`, value: `NR` },
			{ label: `Nepal`, value: `NP` },
			{ label: `Netherlands`, value: `NL` },
			{ label: `New Caledonia`, value: `NC` },
			{ label: `New Zealand`, value: `NZ` },
			{ label: `Nicaragua`, value: `NI` },
			{ label: `Niger`, value: `NE` },
			{ label: `Nigeria`, value: `NG` },
			{ label: `Niue`, value: `NU` },
			{ label: `Norway`, value: `NO` },
			{ label: `Oman`, value: `OM` },
			{ label: `Pakistan`, value: `PK` },
			{ label: `Palestine`, value: `PS` },
			{ label: `Panama`, value: `PA` },
			{ label: `Papua New Guinea`, value: `PG` },
			{ label: `Paraguay`, value: `PY` },
			{ label: `Peru`, value: `PE` },
			{ label: `Philippines`, value: `PH` },
			{ label: `Pitcairn`, value: `PN` },
			{ label: `Poland`, value: `PL` },
			{ label: `Portugal`, value: `PT` },
			{ label: `Puerto Rico`, value: `PR` },
			{ label: `Qatar`, value: `QA` },
			{ label: `Reunion`, value: `RE` },
			{ label: `Romania`, value: `RO` },
			{ label: `Russian Federation`, value: `RU` },
			{ label: `Rwanda`, value: `RW` },
			{ label: `Saint Barthélemy`, value: `BL` },
			{ label: `Saint Helena`, value: `SH` },
			{ label: `Saint Kitts and Nevis`, value: `KN` },
			{ label: `Saint Lucia`, value: `LC` },
			{ label: `Saint Martin (French part)`, value: `MF` },
			{ label: `Saint Pierre and Miquelon`, value: `PM` },
			{ label: `Saint Vincent and the Grenadines`, value: `VC` },
			{ label: `Samoa`, value: `WS` },
			{ label: `San Marino`, value: `SM` },
			{ label: `Sao Tome and Principe`, value: `ST` },
			{ label: `Saudi Arabia`, value: `SA` },
			{ label: `Senegal`, value: `SN` },
			{ label: `Serbia`, value: `RS` },
			{ label: `Seychelles`, value: `SC` },
			{ label: `Sierra Leone`, value: `SL` },
			{ label: `Singapore`, value: `SG` },
			{ label: `Sint Maarten (Dutch part)`, value: `SX` },
			{ label: `Slovakia`, value: `SK` },
			{ label: `Slovenia`, value: `SI` },
			{ label: `Solomon Islands`, value: `SB` },
			{ label: `Somalia`, value: `SO` },
			{ label: `South Africa`, value: `ZA` },
			{ label: `South Georgia and South Sandwich Islands`, value: `GS` },
			{ label: `South Sudan`, value: `SS` },
			{ label: `Spain`, value: `ES` },
			{ label: `Sri Lanka`, value: `LK` },
			{ label: `Sudan`, value: `SD` },
			{ label: `Suriname`, value: `SR` },
			{ label: `Svalbard and Jan Mayen Islands`, value: `SJ` },
			{ label: `Swaziland`, value: `SZ` },
			{ label: `Sweden`, value: `SE` },
			{ label: `Switzerland`, value: `CH` },
			{ label: `Taiwan`, value: `TW` },
			{ label: `Tajikistan`, value: `TJ` },
			{ label: `Tanzania`, value: `TZ` },
			{ label: `Thailand`, value: `TH` },
			{ label: `Timor-Leste`, value: `TL` },
			{ label: `Togo`, value: `TG` },
			{ label: `Tokelau`, value: `TK` },
			{ label: `Tonga`, value: `TO` },
			{ label: `Trinidad and Tobago`, value: `TT` },
			{ label: `Tunisia`, value: `TN` },
			{ label: `Turkey`, value: `TR` },
			{ label: `Turkmenistan`, value: `TM` },
			{ label: `Turks and Caicos Islands`, value: `TC` },
			{ label: `Tuvalu`, value: `TV` },
			{ label: `Uganda`, value: `UG` },
			{ label: `Ukraine`, value: `UA` },
			{ label: `United Arab Emirates`, value: `AE` },
			{ label: `United Kingdom`, value: `GB` },
			{ label: `Uruguay`, value: `UY` },
			{ label: `Uzbekistan`, value: `UZ` },
			{ label: `Vanuatu`, value: `VU` },
			{ label: `Vatican City`, value: `VA` },
			{ label: `Venezuela`, value: `VE` },
			{ label: `Vietnam`, value: `VN` },
			{ label: `Virgin Islands, British`, value: `VG` },
			{ label: `Wallis and Futuna Islands`, value: `WF` },
			{ label: `Western Sahara`, value: `EH` },
			{ label: `Yemen`, value: `YE` },
			{ label: `Zambia`, value: `ZM` },
			{ label: `Zimbabwe`, value: `ZW` },
		],

		DELIVERY_TYPE_LABELS: {
			ELECTRONIC: `E-Ticket`,
			LIVE_STREAM: `Tixr Play`,
			NONE: `No delivery`,
			SHIPPING: `Shipping`,
			THIRD_PARTY: `Event organizer`,
			VIDEO_CHAT: `Tixr Play`,
			VOD: `Tixr Play`,
			WILLCALL: `Will call`,
		},

		DELIVERY_OPTIONS: [
			{ label: `Electronic`, value: `ELECTRONIC` },
			{ label: `Shipping`, value: `SHIPPING` },
			{ label: `Live Stream`, value: `LIVE_STREAM` },
			{ label: `Video On-Demand`, value: `VOD` },
			{ label: `Video Chat`, value: `VIDEO_CHAT` },
			{ label: `Will call`, value: `WILLCALL` },
			{ label: `Third party`, value: `THIRD_PARTY` },
			{ label: `No delivery`, value: `NONE` },
		],

		DELIVERY_SCHEDULE_OPTIONS: [
			{ label: `Immediate`, value: `IMMEDIATE` },
			{ label: `Future`, value: `FUTURE` },
		],

		ELECTRONIC_TYPES_OPTIONS: [
			{ label: `Rotating Digital Code`, value: `ROTATING_DIGITAL_CODE` },
			{ label: `Static Digital Code`, value: `DIGITAL_CODE` },
			{ label: `Contactless`, value: `NFC` },
			{ label: `PDF`, value: `PDF` },
		],

		ADDITIONAL_DELIVERY_OPTIONS: [
			{ label: `Shipping`, value: `SHIPPING` },
			{ label: `Will Call`, value: `WILLCALL` },
		],

		SALE_CATEGORY_ORDER: [
			`GA`,
			`STANDARD`,
			`VIP`,
			`VENDOR`,
			`GUEST`,
			`CABANA`,
			`TABLE_SERVICE`,
			`TABLE`,
			`BOOTH`,
			`PARKING`,
			`SHUTTLE`,
			`CAMPING`,
			`CONSIGNMENT`,
			`OUTLET`,
			`MEDIA`,
			`DONATION`,
			`AUTOGRAPH`,
			`PHOTO`,
			`WORKSHOP`,
			`LODGING`,
			`TRAVEL`,
			`FAST_PASS`,
			`FOOD_AND_BEVERAGE`,
			`MERCHANDISE`,
			`MISCELLANEOUS`,
			`MISCELLANEOUS_2`,
			`MISCELLANEOUS_3`,
			`SKIP_THE_LINE`,
		],

		SALE_CATEGORY_NAMES: {
			AUTOGRAPH: `Autograph`,
			BOOTH: `Booth`,
			CABANA: `Cabana`,
			CAMPING: `Camping`,
			CONSIGNMENT: `Consignment`,
			DONATION: `Donation`,
			FAST_PASS: `Fast Pass`,
			FOOD_AND_BEVERAGE: `Food & Beverage`,
			GA: `General Admission`,
			GUEST: `Guest List`,
			LODGING: `Lodging`,
			MEDIA: `Media`,
			MERCHANDISE: `Merchandise`,
			MISCELLANEOUS: `Miscellaneous`,
			MISCELLANEOUS_2: `Miscellaneous 2`,
			MISCELLANEOUS_3: `Miscellaneous 3`,
			OUTLET: `Outlet`,
			PARKING: `Parking`,
			PHOTO: `Photo Op`,
			SHUTTLE: `Shuttle`,
			SKIP_THE_LINE: `Skip the Line`,
			STANDARD: `Standard`,
			TABLE: `Table`,
			TABLE_SERVICE: `Table Service`,
			TRAVEL: `Travel Package`,
			VENDOR: `Vendor`,
			VIP: `VIP`,
			WORKSHOP: `Workshop`,
		},

		SALE_CATEGORY_ICONS: {
			AUTOGRAPH: `autograph`,
			BOOTH: `booth`,
			CABANA: `cabana`,
			CAMPING: `camping`,
			CONSIGNMENT: `consignment`,
			DONATION: `donation`,
			FAST_PASS: `fastpass`,
			FOOD_AND_BEVERAGE: `food-bev`,
			GA: `ga`,
			GUEST: `guest`,
			LODGING: `bed`,
			MEDIA: `playsymbol`,
			MERCHANDISE: `merch`,
			MISCELLANEOUS: `misc`,
			MISCELLANEOUS_2: `misc`,
			MISCELLANEOUS_3: `misc`,
			OUTLET: `outlet`,
			PARKING: `automobile`,
			PHOTO: `camera`,
			SHUTTLE: `shuttle`,
			SKIP_THE_LINE: `skip-line`,
			STANDARD: `standard`,
			TABLE: `table`,
			TABLE_SERVICE: `bottle`,
			TRAVEL: `airplane`,
			VENDOR: `vendor`,
			VIP: `star`,
			WORKSHOP: `tools`,
		},
		VIDEO_DELIVERY_TYPES: [
			/** Sale / SaleOrder deliveryTypes that involve video content */
			`LIVE_STREAM`,
			`VOD`,
			`VIDEO_CHAT`,
		],
		PAYMENT_METHOD_ICONS: {
			/** BRAINTREE CARD TYPES */
			'American Express': `amex`,
			'Diners Club': `creditcard`,
			Discover: `discover`,
			Elo: `creditcard`,
			Hiper: `creditcard`,
			Hipercard: `creditcard`,
			JCB: `jcb`,
			Maestro: `creditcard`,
			MasterCard: `mastercard`,
			Mir: `creditcard`,
			UnionPay: `creditcard`,
			Visa: `visa`,
			// PAYPAL
			PayPal: `paypal`,

			/** STRIPE CARD TYPES */
			amex: `amex`,
			diners: `creditcard`,
			discover: `discover`,
			jcb: `jcb`,
			mastercard: `mastercard`,
			unionpay: `creditcard`,
			visa: `visa`,
			unknown: `creditcard`,
		},
		EXTERNAL_TENDER_TYPES: [`ACH`, `CHECK`, `WIRE`, `CASH`, `INTERNAL`],
		ADD_ONS_POST_TRANSACTION_SORT_OPTIONS: {
			RECOMMENDED: {
				label: `Recommended`,
				value: `RECOMMENDED`,
			},
			PRICE_LOWEST_TO_HIGHEST: {
				label: `Price: Low-High`,
				value: `PRICE_LOWEST_TO_HIGHEST`,
			},
			PRICE_HIGHEST_TO_LOWEST: {
				label: `Price: High-Low`,
				value: `PRICE_HIGHEST_TO_LOWEST`,
			},
		},
		COLLECTION_SORT_OPTIONS: {
			RECOMMENDED: {
				label: `Recommended`,
				value: `RECOMMENDED`,
			},
			PRICE_LOWEST_TO_HIGHEST: {
				label: `Price: Low-High`,
				value: `PRICE_LOWEST_TO_HIGHEST`,
			},
			PRICE_HIGHEST_TO_LOWEST: {
				label: `Price: High-Low`,
				value: `PRICE_HIGHEST_TO_LOWEST`,
			},
		},
		RESALE_LISTING_SORT_OPTIONS: {
			MIN_PRICE_ASC: {
				label: `Lowest to Highest`,
				shortLabel: `Lowest`,
				value: `MIN_PRICE_ASC`,
			},
			MAX_PRICE_DESC: {
				label: `Highest to Lowest`,
				shortLabel: `Highest`,
				value: `MAX_PRICE_DESC`,
			},
		},

		RESERVED_COLLECTION_LAYOUTS: [`ARENA`, `ARENA_SINGLE_COLUMN`],

		NOTIFICATIONS_PROCESSOR_DOMAINS: {
			dev: `http://localhost:8085`,
			develop: `https://notifications.develop.tixr.com:443`,
			qa: `https://notifications.qa.tixr.com:443`,
			test: `https://notifications.test.tixr.com:443`,
			staging: `https://notifications.staging.tixr.com:443`,
			playground: `https://notifications.playground.tixr.com:443`,
			prod: `https://notifications.tixr.com:443`,
		},

		ACTIVE_STATES: [`OPEN`, `QUEUED`], // states that allow adding sale to cart

		EXPRESS_CHECKOUT_STATES: {
			NULL: `NULL`, // express checkout not yet initialized
			INITIALIZED: `INITIALIZED`, // express checkout initialized, but not yet created
			SUCCESS: `SUCCESS`, // express checkout created successfully
			FAILED: `FAILED`, // express checkout creation failed
		},

		FILTER_SEARCH_BAR_DEFAULTS: {
			filter: {},
			sort: `RECOMMENDED`,
		},

		DISPLAY_RESALE_STATES: [`QUEUED`, `RESALE`, `SOLD_OUT`], // states that allow resale listing to be displayed
	})
		.assign(SiteConfig) // copy over any values from the server at the jsp-level
		.reduce(function (config, value, key) {
			// iterate over all the keys, to create the new Config object
			return Object.defineProperty(config, key, {
				// define each property as read-only
				value,
				writable: false,
				enumerable: true,
			});
		}, {}) // start with a new blank Object
		.value(); // return the Config object that was created from the reduction

	const api = {
		export: (ingester) => config,
		name: `Config`,
		namespace: `Config`,
	};

	_.assign(api, config);

	Object.freeze(config);
	Object.freeze(api);
	return api;
});

//# sourceMappingURL=Config.js.map